import { BrowserRouter as Router } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import * as Sentry from '@sentry/react'
import { PropsWithChildren } from 'react'

import { ClientContextController } from '../context/client/clientContextController/ClientContextController'
import { EducationHostedFormContextController } from '../context/educationHostedForm/EducationHostedFormContextController'
import { CountriesContextController } from '../context/countries/CountryContextController'
import { CaptchaContextController } from '../context/captcha/CaptchaContextController'

import { ThemeProvider } from './ThemeProvider/ThemeProvider'
import { ErrorFallback } from './ErrorFallback'
import { PostHogProvider } from './PostHogProvider/PostHogProvider'
import { i18n } from '@percent/education-hosted-form/i18n/config'

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <PostHogProvider>
        <I18nextProvider i18n={i18n}>
          <Router>
            <CaptchaContextController>
              <ClientContextController>
                <EducationHostedFormContextController>
                  <ThemeProvider>
                    <CountriesContextController>{children}</CountriesContextController>
                  </ThemeProvider>
                </EducationHostedFormContextController>
              </ClientContextController>
            </CaptchaContextController>
          </Router>
        </I18nextProvider>
      </PostHogProvider>
    </Sentry.ErrorBoundary>
  )
}
